import { useDispatch } from "react-redux";
import PlsSubscribePanel from "./FirstVisit/PlsSubscribePanel";
import CloseIcon from "@mui/icons-material/Close";
import { setOverlayVisible } from "../../redux/actions/overlay";

const SubscribeOverlay = () => {
  const dispatch = useDispatch();

  const hideModal = () => {
    dispatch(
      setOverlayVisible({
        visible: false,
        overlayType: "subscribe",
      }),
    );
  };

  return (
    <div className="subscribe-overlay overlay_contents">
      <CloseIcon className="overlay_close-icon" onClick={hideModal} />
      <PlsSubscribePanel next={hideModal} />
    </div>
  );
};

export default SubscribeOverlay;
